import { Card, Box, Typography, Avatar } from "@mui/material";

export default function ShoutoutCard({ data }) {
  return (
    <Card
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: "20px",
        background: "#ECFDF5",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar src={data.senderAvatar} />
        <Avatar src={data.receiverAvatar} />

        <Box>
          <Typography fontWeight={700} color="#059669">
            Shoutout!
          </Typography>

          <Typography fontSize="14px" color="#065F46">
            {data.senderName} gave a shoutout to {data.receiverName}
          </Typography>

          <Typography fontSize="12px" sx={{ mt: 0.3 }} color="text.secondary">
            {new Date(data.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
